exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1MXkoXxRQM2OHhwEFR6znv{width:100%;color:\"[theme:neutralSecondary, default:#605e5c]\"}._2uC-4zm8qC5srsEIjREAvS{font-size:14px;height:25px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", ""]);
// Exports
exports.locals = {
	"weekNumber": "_1MXkoXxRQM2OHhwEFR6znv",
	"weekNumberString": "_2uC-4zm8qC5srsEIjREAvS"
};